import { Component, OnInit } from '@angular/core'

import { AuthService } from '../../../modules/auth/auth.service'

@Component({
  selector: 'lin-blocked-user',
  templateUrl: './blocked-user.component.html',
  styleUrls: ['./blocked-user.component.scss'],
  standalone: false,
})
export class BlockedUserComponent implements OnInit {
  message: string

  constructor(private authService: AuthService) {}

  ngOnInit() {
    this.message = this.authService.getCurrentUserBlockingMessage()
  }
}
